// extracted by mini-css-extract-plugin
export default {"number_control":"NsHinsVrfZ+-NX8gphlAHA==","disabled":"ZNXbTEDkaQh77MmsR66O+w==","display_text":"u9BHXE2zdfoVLVnpdLZm0A==","display_text_wide":"_0gikN9Hiwzao5ijaBQWCrA=="};